import { render, staticRenderFns } from "./outairthreshold.vue?vue&type=template&id=cdf9a510&scoped=true&"
import script from "./outairthreshold.vue?vue&type=script&lang=ts&"
export * from "./outairthreshold.vue?vue&type=script&lang=ts&"
import style0 from "./outairthreshold.vue?vue&type=style&index=0&id=cdf9a510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf9a510",
  null
  
)

export default component.exports